import React, { useEffect, useState } from 'react'
import { getPunchInfo } from '../../services/FunctionKeysService';
import { Box, Card, Divider, Tooltip, Grid, Typography } from '@mui/material';
import CommonUtil from '../../util/CommonUtils';
import CustomOutlinedButton from '../../components/CustomOutlined';
import { REACT_FUNCTION_KEY_SCREEN } from '../../constants/ReactEndPoints';
import { useNavigate } from 'react-router-dom';
import { format } from 'date-fns';
import CustomDatePicker from '../../components/CustomDatePicker';
import dayjs from 'dayjs';
import { getFormattedLocalDate } from '../../util/helperFunction';
import { useTranslation } from 'react-i18next';

const dateFormat ="MM/dd/yyyy"

const PunchInfo = () => {
  const {t} = useTranslation();
  const [toDate, setToDate] = useState(new Date().toISOString().slice(0, 10));
  const [selectedDate, setSelectedDate] = useState(dayjs());
  const [fromDate, setFromDate] = useState("");
  const [punchInfoData, setPunchInfoData] = useState([]);
  const [groupedData, setGroupedData] = useState({});
  const navigate = useNavigate();
  
  useEffect(() => {
    if (CommonUtil.isEmpty(fromDate)) {
      let dateObj = dayjs();
      let fromDate = dateObj.subtract(7, 'day');
      setFromDate(fromDate.format('YYYY-MM-DD'));
    }
  }, []);

  useEffect(() => {
    if (!CommonUtil.isEmpty(fromDate) && !CommonUtil.isEmpty(toDate)) {
      fetchPunchInfoData();
    }
  }, [fromDate, toDate]);

  useEffect(() => {
    if (punchInfoData.length > 0) {
      groupDataByDate();
    }
  }, [punchInfoData]);

  const fetchPunchInfoData = () => {
    getPunchInfo(fromDate, toDate)
      .then((res) => {
        if (res.status === 200 && res.data.message == "Success" && res.data?.data.length > 0) {
          setPunchInfoData(res.data?.data);
        } else {
          setPunchInfoData([]);
          setGroupedData({})
        }
      })
      .catch((error) => {
        console.error("Error while fetching the punch info", error);
      });
  };

  const groupDataByDate = () => {
    const grouped = {};
    punchInfoData.forEach(punch => {
      const date = new Date(punch.punchDate);
      const formattedDate = format(date,dateFormat);
      if (!grouped[formattedDate]) {
        grouped[formattedDate] = [];
      }
      grouped[formattedDate].push(punch);
    });
    // Sort keys in descending order
    const sortedKeys = Object.keys(grouped).sort((a, b) => new Date(a) - new Date(b));
    const sortedGroupedData = {};
    sortedKeys.forEach(key => {
      // Sort array values for each date key in descending order
      sortedGroupedData[key] = grouped[key].sort((a, b) => new Date(a.punchDate) - new Date(b.punchDate));
    });
    setGroupedData(sortedGroupedData);
  };

  const handleCalendar = (toDate) => {
    // Convert toDate to a Day.js object if it's not already one
    let dateObj = dayjs(toDate);
    let fromDate = dateObj.subtract(7, 'day');
    setFromDate(fromDate.format('YYYY-MM-DD'));
    setToDate(dateObj.format('YYYY-MM-DD'));
    setSelectedDate(toDate);
  };

  const handleToday = () => {
    let dateObj = dayjs();
    let fromDate = dateObj.subtract(7, 'day');
      setFromDate(fromDate.format('YYYY-MM-DD'));
      setToDate(dateObj.format('YYYY-MM-DD'));
    setSelectedDate(dayjs())
  }

  return (
    <>
      <Grid
        container
        flexDirection={'column'}
        sx={{
          padding: "0px 20px",
        }}
      >
        <Grid item container justifyContent={'space-between'} sx={{ padding: '10px 15px 0px 15px' }}>
          <Grid item display={'flex'} alignItems={'center'}>
            <Typography variant='lastPunchLabel3'> {t("punchInfo.listTitle")}</Typography>
          </Grid>
          <Grid item display={'flex'} alignItems={'center'} gap={3} >
            <Box>
              <Typography variant='lastPunchLabel2'
                sx={{ color: '#00A4FF', cursor: 'pointer' }}
                onClick={handleToday}
              >
                {t("punchInfo.actions.today")}
              </Typography>
            </Box>
            <CustomDatePicker
              fromDate={fromDate}
              selectedDate={selectedDate}
              handleCalendar={handleCalendar}
            />
          </Grid>
        </Grid>
        {
          !CommonUtil.isEmpty(groupedData) ? (
            <Grid
              container
              spacing={2}
              flexDirection={'row'}
              sx={{
                height: { xs: "300px", sm: "300px", md: "250px", lg: "200px", xl: "350px" },
                overflow: 'auto',
                scrollbarWidth: 'thin',
                padding: "10px"
              }}>
              {Object.keys(groupedData).map(date => (
                <Grid item key={date} xs={6} sm={3} md={1.7} lg={1.7} xl={1.7}>
                  <Card sx={{
                    width: '100%',
                    height: '160px',
                    padding: '10px 5px 10px 10px',
                    display: 'flex',
                    flexDirection: 'column',
                    borderRadius: "10px"
                  }}>
                    <Box display="flex" justifyContent="center" marginBottom="5px">
                      <Typography variant="punchInfoCardLabel1"> {date}</Typography>
                    </Box>
                    <Divider />
                    <Box sx={{ flexGrow: 1, overflowY: 'auto', scrollbarWidth: "thin", marginTop: '10px', }}>
                      {groupedData[date].map(punch => (
                        <Box key={punch.id} sx={{ display: 'flex', marginBottom: '2px' }}>
                          <Box sx={{ width: 'calc(40%)', display: 'flex' }}>
                            <Tooltip title={CommonUtil.getAttendanceState(punch?.eventCode)} arrow>
                              <Typography variant="punchInfoCardLabel2" sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                {CommonUtil.getAttendanceState(punch?.eventCode)}
                              </Typography>
                            </Tooltip>
                          </Box>
                          <Box sx={{ width: 'calc(60%)', display: 'flex', paddingRight: "10px" }} justifyContent={'flex-end'} >
                            <Typography variant="punchInfoCardLabel2" sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                              {getFormattedLocalDate(punch?.punchDate).split(" ")[1]}
                              {getFormattedLocalDate(punch?.punchDate).split(" ")[2]}
                            </Typography>
                          </Box>
                        </Box>
                      ))}
                    </Box>
                  </Card>
                </Grid>
              ))}
            </Grid>
          ) : (
            <Grid item container sx={{ paddingTop: "10%" }} justifyContent={'center'}>
              <Typography>{t("punchInfo.messages.noRecords")}</Typography>
            </Grid>
          )}
        <Grid item container
          sx={{
            position: 'absolute',
            top: "85%",
            left: '20px'
          }}
        >
          <Box sx={{ marginTop: { sm: "0px", md: "10px", lg: "10px" } }}>
            <CustomOutlinedButton onBtnClick={() => navigate(REACT_FUNCTION_KEY_SCREEN)} title={t("punchInfo.buttons.close")} />
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default PunchInfo;
